import React, { useState, useEffect, useCallback } from "react";
import { DragDropContext } from "react-beautiful-dnd";
import toast from "react-hot-toast";
import KanbanBoard from "./KanbanBoard";
import MobileKanbanBoard from "./mobileKanban/MobileKanbanBoard";
import "./kanban.scss";
import "./mobileKanban/mobileKanban.scss";

function Kanban({ workflowSteps, cards, id, boardName, sameWorkFlowIdcards =[]}) {
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);
  const [projects, setProjects] = useState(cards);

  useEffect(() => {
    const handleResize = () => {
      const newIsMobile = window.innerWidth <= 768;
      setIsMobile(newIsMobile);
    };

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  useEffect(() => {
    setProjects(cards);
  }, [cards]);

  const onDragEnd = useCallback(
    (result) => {
      const { source, destination, draggableId } = result;

      if (!destination) return;

      if (source.droppableId === destination.droppableId) return;

      if (destination.droppableId === "todo-column") {
        toast.error("Cannot move a Regular task to Quick Tasks");
        return;
      }

      // Find the card being dragged
      const draggedCard = projects?.find(
        (projectObject) => projectObject?.card?.card_id === Number(draggableId)
      );

      if (!draggedCard) return;

      // Create a new array with the updated card
      const updatedProjects = projects?.map((card) => {
        if (card.card.card_id === Number(draggableId)) {
          return {
            ...card,
            card: {
              ...card.card,
              workflow_step_id: Number(destination.droppableId),
            },
          };
        }
        return card;
      });

      // Update the state with the modified card
      setProjects(updatedProjects);
    },
    [projects]
  );

  return (
    <div>
      {isMobile ? (
        <DragDropContext onDragEnd={onDragEnd}>
          <MobileKanbanBoard
            boardName={boardName}
            workflowSteps={workflowSteps}
            projects={projects}
            id={id}
          />
        </DragDropContext>
      ) : (
        <KanbanBoard
          boardName={boardName}
          workflowSteps={workflowSteps}
          cards={cards}
          id={id}
          sameWorkFlowIdcards={sameWorkFlowIdcards}
        />
      )}
    </div>
  );
}

export default Kanban;
